import { useCallback, useState } from "react";

type RowId = string | number;

export function useExpandableRows<T extends RowId = number>() {
  const [expandedRows, setExpandedRows] = useState<Set<T>>(new Set());

  const toggleRowExpanded = useCallback((id: T) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const isRowExpanded = useCallback(
    (id: T) => expandedRows.has(id),
    [expandedRows]
  );

  const expandRow = useCallback((id: T) => {
    setExpandedRows((prev) => new Set(prev).add(id));
  }, []);

  const collapseRow = useCallback((id: T) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const collapseAll = useCallback(() => {
    setExpandedRows(new Set());
  }, []);

  return {
    expandedRows,
    toggleRowExpanded,
    isRowExpanded,
    expandRow,
    collapseRow,
    collapseAll,
  };
}
